import React from "react";
import axios from "axios";

export const forgotPasswordApi = async (email) => {

  try {
    let url = `https://visapro-api.tcore.online/api/v1/auth/forgot-password`;
    const response = await axios.post(url, {
      email,
    });
    const forgot = {
      data: response,
    };

    return forgot;
  } catch (error) {
    const forgot = {
      error: error,
    };
    return forgot;
  }
};
